import { stdObject } from "../data/types/stdObject";

export const backupArray = (data: stdObject[]) =>
  data
    .map((e: stdObject) => {
      return { ...e, size: (e.size / 1000000).toFixed(0) + " MB" };
    })
    .sort((a: stdObject, b: stdObject) => b.date.localeCompare(a.date));
